import { lazy, Suspense } from 'react';

import { useIsStiggMounted } from '@/lib/stigg/hooks/useIsStiggMounted';

import type { UsageExceededBannerContentProps } from './UsageExceededBannerContent';

// Lazy so the Stigg SDK stays out of the portal chunk; see PortalBillingProvider
// for the matching provider split.
const UsageExceededBannerContent = lazy(() =>
  import('./UsageExceededBannerContent').then((module) => ({
    default: module.UsageExceededBannerContent,
  })),
);

/**
 * Shows `UsageExceededNotice` once Stigg reports the sourcing allowance as
 * fully used. Nothing renders while billing is off, the SDK is loading, or
 * the entitlement is still the fallback, so the page never flashes a limit.
 */
export function UsageExceededBanner(props: UsageExceededBannerContentProps) {
  const isStiggMounted = useIsStiggMounted();

  if (!isStiggMounted) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <UsageExceededBannerContent {...props} />
    </Suspense>
  );
}
